
var id = "editNewMaterial";
var markup = "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"editNewMaterial\">\n<path d=\"M13.3333 11V14C13.3333 14.3682 13.0349 14.6667 12.6667 14.6667H10.5\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"square\" stroke-linejoin=\"round\" />\n<path d=\"M13.3332 5.33325V1.99992C13.3332 1.63173 13.0347 1.33325 12.6665 1.33325H3.33317C2.96498 1.33325 2.6665 1.63173 2.6665 1.99992V13.9999C2.6665 14.3681 2.96498 14.6666 3.33317 14.6666H5.33317\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"square\" stroke-linejoin=\"round\" />\n<path d=\"M5.3335 5.33325H10.0002\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"square\" />\n<path d=\"M7.6665 14.6667L13.3332 7.66675\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"square\" />\n<path d=\"M5.3335 8H8.00016\" stroke=\"white\" stroke-width=\"1.33333\" stroke-linecap=\"square\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
